import { render, staticRenderFns } from "./SearchIcon.vue?vue&type=template&id=7ac0154a&scoped=true"
var script = {}
import style0 from "./SearchIcon.vue?vue&type=style&index=0&id=7ac0154a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac0154a",
  null
  
)

export default component.exports